<template>
  <v-footer>
    <v-col class="text-center" cols="12"> ⓒ{{ new Date().getFullYear() }} — <strong>BestBrickPrice</strong> </v-col>
  </v-footer>
</template>
